import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MissingPropertyInfo } from '../../utils/property-missing-info.utils';

@Component({
  selector: 'etxe-property-section-reminder',
  imports: [CommonModule, MatIconModule, MatButtonModule, MatMenuModule, MatTooltipModule],
  templateUrl: './property-section-reminder.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EtxePropertySectionReminderComponent {
  items = input.required<MissingPropertyInfo[]>();
  editMode = input<boolean>(false);

  actionClicked = output<MissingPropertyInfo>();

  highestSeverity = computed<'critical' | 'warning' | 'info'>(() => {
    const items = this.items();
    if (items.some((i) => i.severity === 'critical')) return 'critical';
    if (items.some((i) => i.severity === 'warning')) return 'warning';
    return 'info';
  });

  onAction(item: MissingPropertyInfo): void {
    this.actionClicked.emit(item);
  }
}
